import * as types from "./actionType";

const initialState = {
  fetchingMembersReports: false,
  membersReportsList: [],
  membersReportsListCount: 0,
  exportToExcelStatus: false,
  fetchingNonMembersReports: false,
  nonMembersReportsList: [],
  nonMembersReportsListCount: 0,
  fetchingRidesReports: false,
  ridesReportsList: [],
  ridesReportsListCount: 0,
  exportToExcelRideReportsStatus: false,
  fetchingEventsReports: false,
  eventsReportsList: [],
  eventsReportsListCount: 0,
  exportToExcelEventReportsStatus: false,
  fetchingBranchReports: false,
  branchReportsList: [],
  branchReportsListCount: 0,
  exportToExcelBranchReportsStatus: false,
  stateStatus: false,
  states: [],
};

function reportsReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_MEMBERS_REPORTS:
      return {
        ...state,
        fetchingMembersReports: true,
      };

    case types.FETCH_MEMBERS_REPORTS_SUCCESS:
      return {
        ...state,
        fetchingMembersReports: false,
        membersReportsList: [...state.membersReportsList, ...action.payload],
        membersReportsListCount: action.count,
      };

    case types.FETCH_MEMBERS_REPORTS_FAILED:
      return {
        ...state,
        fetchingMembersReports: false,
        membersReportsList: [],
      };

    case types.EXPORT_TO_EXCEL:
      return {
        ...state,
        exportToExcelStatus: true,
      };
    case types.EXPORT_TO_EXCEL_SUCCESS: {
      return {
        ...state,
        exportToExcelStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_FAILED: {
      return {
        ...state,
        exportToExcelStatus: false,
      };
    }

    case types.FETCH_NON_MEMBERS_REPORTS:
      return {
        ...state,
        fetchingNonMembersReports: true,
      };

    case types.FETCH_NON_MEMBERS_REPORTS_SUCCESS:
      return {
        ...state,
        fetchingNonMembersReports: false,
        nonMembersReportsList: [
          ...state.nonMembersReportsList,
          ...action.payload,
        ],
        nonMembersReportsListCount: action.count,
      };

    case types.FETCH_NON_MEMBERS_REPORTS_FAILED:
      return {
        ...state,
        fetchingNonMembersReports: false,
        nonMembersReportsList: [],
      };

    case types.FETCH_RIDES_REPORTS:
      return {
        ...state,
        fetchingRidesReports: true,
      };

    case types.FETCH_RIDES_REPORTS_SUCCESS:
      return {
        ...state,
        fetchingRidesReports: false,
        ridesReportsList: [...state.ridesReportsList, ...action.payload],
        ridesReportsListCount: action.count,
      };

    case types.FETCH_RIDES_REPORTS_FAILED:
      return {
        ...state,
        fetchingRidesReports: false,
        ridesReportsList: [],
      };

    case types.EXPORT_TO_EXCEL_RIDES_REPORTS:
      return {
        ...state,
        exportToExcelRideReportsStatus: true,
      };
    case types.EXPORT_TO_EXCEL_RIDES_REPORTS_SUCCESS: {
      return {
        ...state,
        exportToExcelRideReportsStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_RIDES_REPORTS_FAILED: {
      return {
        ...state,
        exportToExcelRideReportsStatus: false,
      };
    }

    case types.FETCH_EVENTS_REPORTS:
      return {
        ...state,
        fetchingEventsReports: true,
      };

    case types.FETCH_EVENTS_REPORTS_SUCCESS:
      return {
        ...state,
        fetchingEventsReports: false,
        eventsReportsList: [...state.eventsReportsList, ...action.payload],
        eventsReportsListCount: action.count,
      };

    case types.FETCH_EVENTS_REPORTS_FAILED:
      return {
        ...state,
        fetchingEventsReports: false,
        eventsReportsList: [],
      };

    case types.EXPORT_TO_EXCEL_EVENTS_REPORTS:
      return {
        ...state,
        exportToExcelEventReportsStatus: true,
      };
    case types.EXPORT_TO_EXCEL_EVENTS_REPORTS_SUCCESS: {
      return {
        ...state,
        exportToExcelEventReportsStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_EVENTS_REPORTS_FAILED: {
      return {
        ...state,
        exportToExcelEventReportsStatus: false,
      };
    }

    case types.FETCH_BRANCH_REPORTS:
      return {
        ...state,
        fetchingBranchReports: true,
      };

    case types.FETCH_BRANCH_REPORTS_SUCCESS:
      return {
        ...state,
        fetchingBranchReports: false,
        branchReportsList: [...state.branchReportsList, ...action.payload],
        branchReportsListCount: action.count,
      };

    case types.FETCH_BRANCH_REPORTS_FAILED:
      return {
        ...state,
        fetchingBranchReports: false,
        branchReportsList: [],
      };

    case types.EXPORT_TO_EXCEL_BRANCH_REPORTS:
      return {
        ...state,
        exportToExcelBranchReportsStatus: true,
      };
    case types.EXPORT_TO_EXCEL_BRANCH_REPORTS_SUCCESS: {
      return {
        ...state,
        exportToExcelBranchReportsStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_BRANCH_REPORTS_FAILED: {
      return {
        ...state,
        exportToExcelBranchReportsStatus: false,
      };
    }

    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        membersReportsList: [],
        fetchingMembersReports: false,
        nonMembersReportsList: [],
        fetchingNonMembersReports: false,
        exportToExcelStatus: false,
        fetchingRidesReports: false,
        ridesReportsList: [],
        exportToExcelRideReportsStatus: false,
        fetchingBranchReports: false,
        branchReportsList: [],
        exportToExcelBranchReportsStatus: false,
        fetchingEventsReports: false,
        eventsReportsList: [],
        exportToExcelEventReportsStatus: false,
      };

    default:
      return state;
  }
}

export default reportsReducer;
